module.exports = __webpack_public_path__ + "media/src/img/speech_to_text-1af6797e1fe3f3f9d53e68c2f71c8da2c9b055f8768921ce28f986b69affe99b.svg";